module.exports = __webpack_public_path__ + "static/media/like-icon.70e37186.svg";